import React, { useEffect, useState } from 'react';
import CustomAccordian from 'src/components/shared/accordian/CustomAccordian';
import AccordianTitleQuestionComponent from './AccordianTitleQuestionComponent';
import { Question, RoundType } from 'types';
import AccordianTitleQuestionComponentMobile from './AccordianTitleQuestionComponentMobile';
import { difficultyNumberToTextMapping } from 'shared-utils';
import StudentEditor from 'src/components/quiz/Editor';
import { formatTimeInHMS } from 'src/utils/helper';
import { useMediaQuery } from '@mui/material';

interface Props {
	index: number;
	questionData: {
		question: Question;
		score: number;
		timeTaken: number;
		questionType: RoundType;
		assessedSkills: { _id: string; name: string; isSoftSkill: boolean }[];
	};
}

const QuestionContainer = ({ index, questionData }: Props) => {
	const isMobile = useMediaQuery('(max-width:960px)');

	return (
		<>
			{isMobile ? (
				<AccordianTitleQuestionComponentMobile
					question={{
						serialNumber: index + 1,
						title: questionData?.question?.title ?? 'Question',
						level: difficultyNumberToTextMapping(questionData.question.difficulty),
						score: Number((questionData.score * 10).toFixed(1)),
						timeTaken: formatTimeInHMS(Number(questionData.timeTaken ?? 0)),
						skillsAssessed: questionData.assessedSkills,
					}}
				/>
			) : (
				<CustomAccordian
					title={({ isOpen }) => (
						<AccordianTitleQuestionComponent
							isOpen={isOpen}
							question={{
								serialNumber: index + 1,
								title: questionData?.question?.title ?? '',
								level: difficultyNumberToTextMapping(questionData.question.difficulty),
								score: Number((questionData.score * 10).toFixed(1)),
								timeTaken: formatTimeInHMS(Number(questionData.timeTaken ?? 0)),
								skillsAssessed: questionData.assessedSkills,
							}}
						/>
					)}
					content={
						<>
							<div className="px-8 py-4 dark:bg-[#18222D]">
								<div className="font-bold text-sm">Question:</div>
								{questionData.question?.content.type === 'prepleaf-editor-raw-content' ? (
									<div className="mt-1 dark:text-white text-sm">
										<StudentEditor readOnly={true} content={questionData.question?.content?.body} />
									</div>
								) : (
									<div
										className="mt-1 question-content-parent-div"
										dangerouslySetInnerHTML={{
											__html: questionData.question?.content?.body
												? `${questionData.question?.content?.body}`
												: 'No content!',
										}}
									/>
								)}
							</div>
						</>
					}
				/>
			)}
		</>
	);
};

export default QuestionContainer;
